import { jsx, jsxs } from 'react/jsx-runtime';
import { useState, useEffect, useCallback } from 'react';
import classNames from '../../../node_modules/.pnpm/classnames@2.5.1/node_modules/classnames/index.js';
import usePrevious from '../../hooks/usePrevious.js';
import { Button } from '../Button/Button.js';
import { Modal } from '../Modal/Modal.js';
import { ProgressBar } from '../ProgressBar/ProgressBar.js';
import style from './FeatureTour.module.css.js';

const FeatureTour = ({ isOpen, slides, completeLabel, closeOnFinish, restartOnClose, onComplete, onClose, }) => {
    const [currentSlide, setCurrentSlide] = useState(0);
    const previousCurrent = usePrevious(currentSlide);
    useEffect(() => {
        if (isOpen) {
            slides[currentSlide].onDisplay?.();
        }
    }, [currentSlide, slides, isOpen]);
    const handleFinish = () => {
        onComplete?.();
        if (closeOnFinish) {
            handleClose();
        }
    };
    const handleNext = (slideIndex) => {
        slides[slideIndex]?.onNext?.();
    };
    const handleClose = useCallback(() => {
        if (restartOnClose) {
            setCurrentSlide(0);
        }
        onClose?.();
    }, [onClose, restartOnClose]);
    return (jsx(Modal, { open: isOpen, className: style.tourModal, onClose: handleClose, children: jsxs("div", { className: style.featureTour, children: [jsx("div", { className: style.imageWrapper, children: slides.map((element, index) => {
                        return (jsx("div", { className: classNames(style.item, index === currentSlide && [style.active, style.fadeIn], index === previousCurrent && style.fadeOut), children: jsx("img", { className: style.image, src: element.img }) }, `${element.title}-${element.description}`));
                    }) }), jsxs("div", { className: style.content, children: [slides.map((element, index) => {
                            return (jsxs("div", { className: classNames(style.itemContent, index === currentSlide && [style.active, style.fadeIn], index === previousCurrent && style.fadeOut), children: [jsx("div", { className: style.title, children: element.title }), jsx("div", { children: element.description })] }, `${element.title}-${element.description}`));
                        }), jsxs("div", { className: style.progress, children: [jsx("div", { style: { marginRight: "auto" }, children: jsx(ProgressBar, { percentage: currentSlide / (slides.length - 1) }) }), jsx(Button, { onClick: () => {
                                        if (currentSlide < slides.length - 1) {
                                            handleNext(currentSlide);
                                            setCurrentSlide((prev) => {
                                                return prev + 1;
                                            });
                                        }
                                        else {
                                            handleFinish();
                                        }
                                    }, children: currentSlide < slides.length - 1 ? "Next" : completeLabel })] })] })] }) }));
};

export { FeatureTour };
//# sourceMappingURL=FeatureTour.js.map
